import React from 'react';
import { Check } from 'lucide-react';

export const PLANNING_STEPS = [
  { key: 'projects', label: 'Projekte auswählen' },
  { key: 'route', label: 'Tourenoptimierung' },
  { key: 'staff', label: 'Mitarbeiterplanung' }
];

/**
 * Schrittanzeige der Tourenplanung. Zurück ist immer möglich,
 * vorwärts nur, wenn der jeweilige Schritt freigegeben ist (canEnter).
 */
const TourPlanningStepper = ({ current, onStepClick, canEnter = {} }) => {
  const currentIndex = PLANNING_STEPS.findIndex(s => s.key === current);

  return (
    <nav aria-label="Planungsschritte" className="flex items-center gap-2 overflow-x-auto">
      {PLANNING_STEPS.map((step, index) => {
        const isDone = index < currentIndex;
        const isActive = index === currentIndex;
        const enabled = isDone || isActive || canEnter[step.key];
        return (
          <React.Fragment key={step.key}>
            {index > 0 && <div className={`h-px w-6 sm:w-10 flex-shrink-0 ${isDone || isActive ? 'bg-blue-400' : 'bg-gray-300'}`} />}
            <button
              type="button"
              disabled={!enabled || isActive}
              onClick={() => onStepClick(step.key)}
              aria-current={isActive ? 'step' : undefined}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                isActive
                  ? 'bg-blue-600 text-white'
                  : isDone
                    ? 'bg-blue-50 text-blue-700 hover:bg-blue-100'
                    : enabled
                      ? 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                      : 'bg-gray-100 text-gray-400 cursor-not-allowed'
              }`}
            >
              <span className={`flex items-center justify-center w-5 h-5 rounded-full text-xs ${isActive ? 'bg-white text-blue-600' : isDone ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'}`}>
                {isDone ? <Check size={12} /> : index + 1}
              </span>
              {step.label}
            </button>
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default TourPlanningStepper;
